import React, { useState, useEffect } from "react";
import "../../index.scss";
import { useHistory, useParams } from "react-router-dom";
import AuditLoggingMain from '../AuditLogging/AuditLoggingMain';
import { getLogsById } from "../AuditLogging/AuditLogsAPIs";

export default (props) => {
    const [showLoadingIcon, setShowLoadingIcon] = useState(true);
    const [logsData, setLogsData] = useState();

    const [headerHref, setHeaderHref] = useState()
    const [sideNavBack, setSideNavBack] = useState()
    const [sideHeader, setSideHeader] = useState("Audit Logs")

    let { id: paramId } = useParams();
    let { lpid: paramLpid } = useParams();

    const id = props.id || paramId;
    const lpid = props.lpid || paramLpid;


    useEffect(() => {
        loadData();
        window.scrollTo(0, 0)
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);


    const loadData = async () => {
        setShowLoadingIcon(true);
        setHeaderHref(`/App/${id}/logico/${lpid}/LogicoProcessAuditLogs`);
        setSideNavBack(`/App/${id}/logico/${lpid}`);
        
        const processPk = `LOGICO#${lpid}`;
        const appPk = `APP#${id}`;
        
        setSideHeader(`Audit Logs of ${processPk}`);
        
        const processLogs = await getLogsById(processPk);
        
        const appLogs = await getLogsById(appPk);
        
        const taggedProcessLogs = processLogs.map(log => ({
            ...log,
            source: 'Process'
        }));
        
        const taggedAppLogs = appLogs.map(log => ({
            ...log,
            source: 'App'
        }));
        
        const mergedLogs = [...taggedProcessLogs, ...taggedAppLogs].sort((a, b) => 
            b.last_updated_time_stamp - a.last_updated_time_stamp
        );
        
        setLogsData(mergedLogs);
        setShowLoadingIcon(false);
    };

    return (
        <AuditLoggingMain 
            logsData={logsData} 
            headerHref={headerHref} 
            sideNavBack={sideNavBack} 
            sideHeader={sideHeader} 
            disableAppLayout={props.disableAppLayout}
            showSourceColumn={true}
        />
    );
};
